// "/uploads/avatars/x.webp" -> full URL (same pattern as your attachment URLs)
export const avatarSrc = (avatar) => {
  if (!avatar) return undefined
  if (/^(https?:\/\/|blob:|data:)/.test(avatar)) return avatar     // full URL or a local preview
  const base = (process.env.REACT_APP_SERVER_URL || '').replace(/\/$/, '')
  return `${base}${avatar.startsWith('/') ? '' : '/'}${avatar}`
}

const isLetter = (ch) => /\p{L}/u.test(ch)          // any language, never digits or symbols
const isUpper = (ch) => ch !== ch.toLowerCase()

// "Anna Smith" -> "AS", "JohnSmith" -> "JS", "001Admin" -> "A", "admin2" -> "A", "001" -> "-"
export const getInitials = (name = '', max = 2) => {
  const words = String(name ?? '')
    .trim()
    .split(/[\s._\-]+/)
    .filter(Boolean)
    .filter((w) => Array.from(w).some(isLetter))      // ignore words like "001"

  if (words.length === 0) return '-'

  const firstLetter = (w) => Array.from(w).find(isLetter)
  const first = firstLetter(words[0])

  if (max <= 1) return first.toUpperCase()

  // Several words: first letter of the first two
  if (words.length >= 2) return (first + firstLetter(words[1])).toUpperCase()

  // One word: add a second capital if it has one ("SimbaLink" -> "SL")
  const chars = Array.from(words[0])
  const at = chars.findIndex(isLetter)
  const second = chars.slice(at + 1).find((ch) => isLetter(ch) && isUpper(ch))

  return (first + (second || '')).toUpperCase()
}

// Same username = same avatar color.
// Avoid green hues so the online badge remains easy to distinguish.
export const avatarColor = (name = '', mode = 'light') => {
  let hash = 0

  for (const ch of String(name ?? '')) {
    hash = (hash * 31 + ch.codePointAt(0)) >>> 0
  }

  const hues = [
    210, 225, 245, 265, 285, 315, 340, 5, 25, 45, 185,
  ]

  const hue = hues[hash % hues.length]
  const opacity = 0.5

  return mode === 'dark'
    ? {
        bgcolor: `hsla(${hue}, 65%, 76%, ${opacity})`,
        color: '#172033',
      }
    : {
        bgcolor: `hsla(${hue}, 65%, 38%, ${opacity})`,
        color: '#ffffff',
      }
}